import { QueryClient } from '@tanstack/react-query';

import { ApiError } from '@/services/ApiError';

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 60_000,
        gcTime: 5 * 60_000,
        refetchOnWindowFocus: false,
        // A missing vehicle will not appear on retry.
        retry: (failureCount, error) =>
          !(error instanceof ApiError && error.kind === 'not_found') && failureCount < 2,
      },
      mutations: { retry: 0 },
    },
  });
}
